'use client';

import cx from 'classix';
import { useAtomValue } from 'jotai/index';
import { useHydrateAtoms } from 'jotai/utils';

import APP_CONFIG from '@/configs/app-config';
import BlogCard from '@/features/blog/components/blog-card/blog-card';
import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { listingsViewAtom } from '@/features/listing/atoms/listings-view-atom';
import ListingCard from '@/features/listing/components/listing-card/listing-card';
import {
  type ListingCardView,
  type ListingWithUser,
} from '@/features/listing/types/listing-types';

import styles from './listings-list.module.scss';

interface ListingsListProps {
  listings: ListingWithUser[],
  savedListingView?: ListingCardView | null,
  showBlogPost?: boolean,
}

interface BlogPostTrigger {
  type: 'blogPost',
}

export default function ListingsList(props: ListingsListProps) {
  const {
    listings,
    savedListingView,
    showBlogPost,
  } = props;

  useHydrateAtoms([[listingsViewAtom, savedListingView ?? APP_CONFIG.defaultListingCardView]]);

  const isMapView = useAtomValue(isMapViewAtom);
  const listingView = useAtomValue(listingsViewAtom);

  const cardsData: (ListingWithUser | BlogPostTrigger)[] = [...listings];
  const blogPostPlaceOnPage = 8;

  if (showBlogPost) {
    cardsData.splice(blogPostPlaceOnPage, 0, { type: 'blogPost' });
  }

  return (
    <div
      className={cx(
        styles.listingsList,
        styles[`listingsList__${listingView}`],
        isMapView && styles.listingsList__isMapView,
      )}
    >
      {cardsData.map((card) => {
        if ('type' in card) {
          return (
            <div key="blog-post" className={styles.listingsList_listingCard}>
              <BlogCard />
            </div>
          );
        }

        return (
          <div key={card.id} className={styles.listingsList_listingCard}>
            <ListingCard
              listing={card}
              listingViewVariant={listingView}
              messageSrc="search-grid"
            />
          </div>
        );
      })}
    </div>
  );
}
